    import React from 'react';
import swal from '../../../helpers/swal.lib';
import { redirectTo, openNewTab } from '../../../helpers/redirect.lib';
import { paths } from '../../../config/routes'
import apiConfig from '../../../config/api';
import { getSolicitudesApi } from '../../../services/solicitudesApi';

const userHaveRequests = async (rut) => {
  const solicitudes = await getSolicitudesApi(rut);
  if (solicitudes.ok) {
    const result = await solicitudes.json();
    if(result.Data.length > 0)
      return true;
  }
  return false;
}

export const validateUserWOCompany = async (result) => {
    //Usuario dependiente sin empresa
    if(result.Menu.Functionalities.find(p => p.ProfileCode === "PER_TRABAJADOR" && p.RolName.toUpperCase() === "EX-ACHS")) {
        if(!result.Companies || result.Companies.length === 0) {
          if(!await userHaveRequests(result.RUT))
            return true;
        }
    }
    return false;
}

export const showMessageUserWOCompany = () => {
    return setTimeout(() => {
        swal.dialogConfirm(null,
        <div>
          <br />
          <h3 className="dx-popup-confirm-title">No tenemos información de tu empleador</h3>
          <br />
          <p style={{ fontSize: '.9em' }}>
            ¿Quieres vincular tu cuenta con una empresa adherida a la ACHS?
          </p>
        </div>,
        "Sí, por favor",
        "Mi empleador no es ACHS",
        false,
        true,
        "dx-popup-confirm-deny-button",
        "dx-popup-confirm-ok-button",
        "dx-popup-confirm").then((result) => {
          if(result.isConfirmed) {
            redirectTo(paths.solicitudesTrabajador);
          } else if (result.isDenied) {
            openNewTab(apiConfig.afiliateAchsUrl);
          }
        });
      }, 5000);
}
